export const TEST_ID = 'StripePricingTable';

export const STRIPE_PRICING_TABLE_PUBLISHABLE_KEY = import.meta.env
    .VITE_STRIPE_PRICING_TABLE_PUBLISHABLE_KEY;
